import { MongoObservable } from 'meteor-rxjs';
import { SettingsModel } from '../models/settingsModel';

export const Settings = new MongoObservable.Collection<SettingsModel>(
  'settings',
);
